import theme from './theme.js'
import headline from './headline.js'
import catalogue from './catalogue.js'
import thanks from './thanks.js'



export default {
	theme,
	catalogue,
	headline,
	thanks
}